/// <reference path="../../global/fn.js" />

(function ($) {
    $.widget("nsp.simpleMasonry", {
        opts: {
            
        },

        _create: function () {
            this.wrap = this.element;

            this._splitBoxes();  
            
        },
        _splitBoxes: function(){           
            var leftCol = this.wrap.find('.s-product-feats__left').eq(0);
            var rightCol = this.wrap.find('.s-product-feats__right').last();
            var oddItems =  this.wrap.find('.b-prod-benef-box').clone().odd();
            var evenItems =  this.wrap.find('.b-prod-benef-box').clone().even();
           
            oddItems.appendTo(rightCol)
            evenItems.appendTo(leftCol)
        }        
    });
})(jQuery);
